import { useCartStore } from "~/store/CartStore";
import { useProductStore } from "~/store/ProductStore";
import { useUserStore } from "~/store/UserStore";

// For using http call
export const useUnAuthorize = async (ctx) => {

  const userStore = useUserStore();
  const cartStore = useCartStore();
  const productStore = useProductStore();
  const route = useRoute();
  if (route.path.includes("/account/login")) {
    return;
  }
  // const router = useRouter();
  // const localePath = useLocalePath();

  const { t } = useNuxtApp().$i18n;

  useNuxtApp().$showToast({ msg: t("session_expired"), type: "error" });
  // Logout http h3
  cartStore.resetCartStates();
  await userStore.logout();
  useCookie("isAuthenticated").value = null;
  productStore.setProductsBackOrders({});
  userStore.removeIsAuthenticated();
  // Check if already on login page

  // router.push(localePath(`/account/login?redirectTo=${route.fullPath}`));
  await navigateTo(`/account/login?redirectTo=${route.fullPath}?ctx=${ctx}`, {
    external: true,
  });
};
